module.exports = __webpack_public_path__ + "static/media/6S.dd29ca5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/6S.svg
// module id = 72
// module chunks = 0